module.exports = __webpack_public_path__ + "img/btn02.d1fa68d2.svg";